import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
export var largeTextGroupStyle = {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20px',
    gap: 1,
};
export var blueTextStyle = {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '20px',
    gap: 1,
    color: appColors.color.blue1,
    mt: 2,
};
export var howToApplyHeaderStyle = {
    mt: 2,
    mb: 3,
    fontSize: '22px',
    borderBottom: '1px solid',
    borderColor: appColors.neutral.black,
    paddingBottom: 2,
    lineHeight: '20px',
    gap: 1,
    color: appColors.neutral.black,
};
export var unorderedListStyle = {
    paddingLeft: '20px',
    marginTop: 4,
    marginBottom: 0,
    color: appColors.neutral.black,
    fontWeight: 400,
};
export var largeScholarshipContainerStyle = {
    mt: 3,
    gap: 2,
    display: 'flex',
    flexDirection: 'column',
};
